import React from 'react'
import cochez from '../../assets/cochez.svg'
import novey from '../../assets/novey.svg'
import './navBar.css'

export default function NavBar({ company }) {
  return (
    <div
      className={
        company === 'CO'
          ? 'navbar-product-search color-navbar-cochez'
          : company === 'NO'
          ? 'navbar-product-search color-navbar-novey'
          : 'navbar-product-search color-navbar-cochez'
      }>
      <img
        src={company === 'CO' ? cochez : company === 'NO' ? novey : cochez}
      />
    </div>
  )
}
